import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, CardHeader, CardContent, TextField, Button, Box, Stack, Alert } from '@mui/material';
import apiClient from '../utils/apiClient';
import { PBM } from '../types';
import PBMConnectionTable from './components/PBMConnectionTable';

const PBMDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [pbm, setPbm] = useState<PBM>({ pbmName: '' });
    const [error, setError] = useState<string>();

    useEffect(() => {
        apiClient.get<PBM>(`/api/PBM/${id}`)
            .then(data => setPbm(data))
            .catch(err => {
                console.error('[PBMDetail] Error fetching PBM:', err);
                setError('Failed to load PBM details');
            });
    }, [id]);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        try {
            await apiClient.patch(`/api/PBM/${id}`, pbm);
            navigate('/pbm');
        } catch (error) {
            console.error('[PBMDetail] Error updating PBM:', error);
            setError('Failed to update PBM');
        }
    };

    const handleDelete = async () => {
        try {
            await apiClient.delete(`/api/PBM/${id}`);
            navigate('/pbm');
        } catch (error) {
            console.error('[PBMDetail] Error deleting PBM:', error);
            setError('Failed to delete PBM');
        }
    };

    return (
         <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 4 }}>
            <Stack spacing={3}>
                <Card>
                    <CardHeader title="Edit PBM" />
                    <CardContent>
                        {error && (
                            <Alert severity="error" sx={{ mb: 2 }}>
                                {error}
                            </Alert>
                        )}
                        <form onSubmit={handleSubmit}>
                            <TextField
                                fullWidth
                                label="PBM Name"
                                value={pbm.pbmName}
                                onChange={(e) => setPbm({ ...pbm, pbmName: e.target.value })}
                                required
                                inputProps={{ maxLength: 100 }}
                                margin="normal"
                            />
                            <Stack direction="row" spacing={2}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{ mt: 2 }}
                                >
                                    Save
                                </Button>
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="error"
                                    sx={{ mt: 2 }}
                                    onClick={handleDelete}
                                >
                                    Delete
                                </Button>
                            </Stack>
                        </form>
                    </CardContent>
                </Card>

                <PBMConnectionTable pbmId={Number(id)} />
            </Stack>
        </Box>
    );
};

export default PBMDetail;
